export enum NotificationsTypesEnum {
    SUPER_LIKE = 'superLike', 
    NEW_MESSAGE = 'newMessage', 
    EXTERNAL_URL = 'externalUrl', 
    NEW_MATCH = 'newMatch',
    NEW_LIKES = 'newLikes',
    DARK_MODE = 'darkMode',
}